module.exports = __webpack_public_path__ + "img/lan_tour_title.299506bf.jpg";